"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _View2 = require("./View");

var _View3 = _interopRequireDefault(_View2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = function (_View) {
    (0, _inherits3.default)(Page, _View);

    function Page() {
        (0, _classCallCheck3.default)(this, Page);
        return (0, _possibleConstructorReturn3.default)(this, (Page.__proto__ || (0, _getPrototypeOf2.default)(Page)).apply(this, arguments));
    }

    (0, _createClass3.default)(Page, [{
        key: "pageWillBackTo",


        // constructor(props, context){
        //     super(props, context);

        //     if(context.history.action === "POP"){
        //         this.pageDidBackFrom();
        //     }
        // }
        // 即将回退到上个页面
        value: function pageWillBackTo(url) {}
        // 刚从上一个页面后退回来

    }, {
        key: "pageDidBackFrom",
        value: function pageDidBackFrom(url) {}
    }]);
    return Page;
}(_View3.default);

Page.contextTypes = (0, _extends3.default)({}, _View3.default.contextTypes, {
    history: _propTypes2.default.object });
exports.default = Page;


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_web-router@0.2.0-alpha.1@@bone/web-router/lib/Page.js
// module id = 2547
// module chunks = 4